<template>
    <div class="Brackets">
        <mNav :msg="msg" :IsHome="true"></mNav>
        <div class="list_box" v-if="NavTree && NavTree.length > 0">
            <van-collapse v-model="activeNames" v-for="(item,index) in NavTree" :key="index"  
            :style="{'border':'1px solid #3277BC','margin-top':'0.15rem'}">
            <!-- <el-card> -->
                <van-collapse-item :name="index">
                    <template #title>
                            <div>{{ item.DisplayName }}</div>
                    </template>
                        <template>
                            <div>
                                <van-collapse v-model="activeNamesc" v-for="(items) in item.Children" :key="items.PhaseId"  
                                    :style="{'border':'1px solid #3277BC','margin-top':'0.15rem'}" v-show="items.PhaseIsPool  == 0">
                                    <!-- <el-card> -->
                                        <van-collapse-item :name="items.PhaseId" v-if="items.PhaseIsPool  == 0">
                                            <template #title>
                                                    <div>{{ items.DisplayName }}</div>
                                            </template>
                                                <template>
                                                    <div>
                                                        <van-collapse v-model="activeNamescc"   
                                                            :style="{'border':'1px solid #3277BC','margin-top':'0.15rem'}">
                                                            <!-- <el-card> -->
                                                                <van-collapse-item :name="iii.PhaseId" v-for="(iii) in items.Children" :key="iii.PhaseId" disabled
                                                                :style="{'border-bottom':'1px solid #3277BC'}">
                                                                    <template #title>
                                                                            <div>{{ iii.DisplayName }}</div>
                                                                    </template>
                                                                    <template  #right-icon >
                                                                        <div class="icons" ><i @click.stop="handPDF(iii)" class="iconfont icon-pdf"></i></div>
                                                                    </template>
                                                                </van-collapse-item>
                                                            <!-- </el-card> -->
                                                            </van-collapse>
                                                    </div>
                                                </template>
                                            <template  #right-icon >
                                                <div class="icons" ><i @click.stop="handPDF(items)" class="iconfont icon-pdf"></i></div>
                                            </template>
                                        </van-collapse-item>
                                    <!-- </el-card> -->
                                    </van-collapse>
                            </div>
                        </template>
                    <template  #right-icon >
                        <div class="icons" ><i class="van-icon van-icon-arrow van-cell__right-icon"></i></div>
                    </template>
                </van-collapse-item>
            <!-- </el-card> -->
            </van-collapse>
        </div>
        <van-empty v-else :description="$t('message.Resut.nodata')" />
        <el-dialog width="90%" :visible.sync="pdfVisible">
            <!-- <pdf :src="pdfUrl" ref="pdf" v-for="i in numPages" :key="i" :page="i"></pdf> -->
            <div id="demo"></div>
        </el-dialog>
    </div>
</template>

<script>
import mNav from "@/components/mNav.vue";
import http from '@/assets/js/http.js';
import axios from 'axios';
import { Dialog ,ImagePreview} from 'vant';
import {Loading} from 'element-ui';
import tree from '@/assets/common/NavTree.json';
import Pdfh5 from "pdfh5";
import "pdfh5/css/pdfh5.css";
export default {
    name: "Brackets",
    components: {
        mNav,
    },
    data() {
        return {
            msg: sessionStorage.SportName,
            NavTree: [],
            activeNames:[],
            activeNamesc: [],
            activeNamescc: [],
            pdfVisible: false,
            pdfh5: null,
            loadingInstance: {},
        }
    },
    mounted() {
        this.loadingInstance = Loading.service({
            lock: true,
            text: '正在加载,请稍后...',
        });
        http.GetFile('/Sports/BDM/'+sessionStorage.SportCode+'/NavTree.json?v='+Math.random()).then(res=>{//获取赛事列表地址
            this.loadingInstance.close();  // 关闭加载遮罩层
            console.log(res)
            if(Array.isArray(res)){
                this.NavTree = res;
            }else{
                this.NavTree = [];
            }
        })
    },
    methods: {
        handPDF(i){
            console.log(i)
            let index = i.FileName .lastIndexOf(".")
            let str = i.FileName.substring(index+1,i.FileName.length);
            console.log(str) //
            axios.get('/Sports/BDM/'+sessionStorage.SportCode+'/Files/'+i.FileName+'?v='+Math.random()).then(res=>{
                console.log(res)
                this.loadingInstance.close();  // 关闭加载遮罩层
                if(res.status == 200) {
                    if(str.toLowerCase() == 'png' && str.toLowerCase() == 'jpg' && str.toLowerCase() == 'jpeg' && str.toLowerCase() == 'gif'){
                        ImagePreview(['http://39.100.55.139:10015/Sports/BDM/'+sessionStorage.SportCode+'/Files/'+i.FileName+'?v='+Math.random()]);
                    }else if(str.toLowerCase() == 'pdf'){
                        this.pdfVisible = true;
                        let _this = this;
                        setTimeout(()=>{
                            //实例化
                            this.pdfh5 = new Pdfh5("#demo", {
                                pdfurl: 'http://39.100.55.139:10015/Sports/BDM/'+sessionStorage.SportCode+'/Files/'+i.FileName+'?v='+Math.random(),
                                lazy: true, //是否懒加载,默认false
                                renderType: 'canvas', // canvas、svg，默认canvas
                                maxZoom: 3, //手势缩放最大倍数,默认3
                                scrollEnable: true, //是否允许pdf滚动,默认true
                                zoomEnable: true,// 是否允许pdf手势缩放,默认true
                                limit: 0, //限制pdf加载最大页数,默认0不限制
                            });
                            
                            //监听完成事件
                            this.pdfh5.on("complete", function (status, msg, time) {
                                console.log("状态：" + status + "，信息：" + msg + "，耗时：" + time + "毫秒，总页数：" + this.totalNum)
                                if(this.totalNum == null){
                                    _this.pdfVisible = false;
                                    Dialog.alert({
                                        message: 'pdf加载失败',
                                    }).then(() => {
                                        // let loadingInstance = Loading.service();
                                        // // this.$nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
                                        //     loadingInstance.close();
                                            
                                    });
                                }
                                // if(status == 'error'){
                                //     // _this.pdfVisible = false;
                                //     _this.title = 'pdf加载失败'
                                //     // Dialog.alert({
                                //     //     message: 'pdf加载失败',
                                //     // }).then(() => {
                                //     //     // let loadingInstance = Loading.service();
                                //     //     // // this.$nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
                                //     //     //     loadingInstance.close();
                                            
                                //     //     // });
                                //     // });
                                // }else if(status == 'success'){
                                //     _this.title = ''
                                // }
                            })
                        },500)
                    }else {
                        let u = navigator.userAgent;
                        if (u.indexOf('Android') > -1 || u.indexOf('Linux') > -1) {//安卓手机
                            // alert("安卓手机");
                            window.open('http://39.100.55.139:10015/Sports/BDM/'+sessionStorage.SportCode+'/Files/'+i.FileName+'?v='+Math.random());
                        } else if (u.indexOf('iPhone') > -1) {//苹果手机
                            // alert("苹果手机");
                            location.href = 'http://39.100.55.139:10015/Sports/BDM/'+sessionStorage.SportCode+'/Files/'+i.FileName+'?v='+Math.random();
                        } else if (u.indexOf('Windows Phone') > -1) {//winphone手机
                            // alert("winphone手机");
                            location.href = 'http://39.100.55.139:10015/Sports/BDM/'+sessionStorage.SportCode+'/Files/'+i.FileName+'?v='+Math.random();
                        }else{
                            window.open('http://39.100.55.139:10015/Sports/BDM/'+sessionStorage.SportCode+'/Files/'+i.FileName+'?v='+Math.random());
                        }
                    }
                }else{
                    Dialog.alert({
                        message: '暂未上传该比赛文件'
                    }).then(() => {
                        let loadingInstance = Loading.service();
                        this.$nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
                           loadingInstance.close();  // 关闭加载遮罩层
                        });
                    });
                }
            })
            
        }
    },
}
</script>

<style lang="scss" scoped>
    $bgColor: #3277BC;
    ::v-deep .van-collapse-item__title--disabled, .van-collapse-item__title--disabled .van-cell__right-icon{
        color: #333;
    }
    ::v-deep .pinch-zoom-container{
        min-height: 450px;
        height: auto;
    }
    .Brackets{
        font-size: 0.2rem;
    }
    .list_box{
        padding: 0.2rem;
    }
    .lis{
        padding: 0.2rem 0;
        background: white;
        border-bottom: 1px solid $bgColor;
        text-indent: 0.3rem;
        font-size: 0.3rem;
    }
</style>